module.exports = __webpack_public_path__ + "img/apple-button.842d8ddf.png";